import React, { useEffect, useState } from "react";
import i18n from "i18next";

import { useNavigate } from "react-router-dom";
import {
  MessageBar,
  MessageBarActions,
  MessageBarBody,
  Button,
  Link,
} from "@fluentui/react-components";

function CookieBanner(props: any) {
  const [cookieAccepted, setCookieAccepted] = useState(false);

  useEffect(() => {
    var accepted = localStorage.getItem("Luebbering_Digital_CookieAccepted");
    setCookieAccepted(accepted == null || accepted == "0" ? false : true);
  }, []);

  const navigate = useNavigate();

  return (
    <div>
      {cookieAccepted == false && (
        <div>
          <MessageBar intent={"warning"}>
            <MessageBarBody>
              {i18n.t<string>("cookieText")}
              <Link
                style={{ marginLeft: "5px" }}
                onClick={() => navigate("/termsofuse")}
              >
                {i18n.t<string>("terms-of-use")}
              </Link>
            </MessageBarBody>
            <MessageBarActions
              containerAction={
                <Button
                  onClick={() => {
                    localStorage.setItem(
                      "Luebbering_Digital_CookieAccepted",
                      "1",
                    );
                    setCookieAccepted(true);
                    navigate(0);
                  }}
                >
                  {i18n.t<string>("close")}
                </Button>
              }
            ></MessageBarActions>
          </MessageBar>
        </div>
      )}
    </div>
  );
}

export default CookieBanner;
